import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CallState } from '@lcs/shared/api';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config/app-config-service';
import { getCurrentUserIsAdminUser } from 'src/app/authentication/state/authentication.selector';
import { NavigatableDetail } from 'src/app/common-components/detail/detail';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { getAccountPrivileges, getExtensionPrivileges } from 'src/app/privileges/privileges.selector';
import { accountRegisterAdapterActions } from '../../account-register/state/account-register.actions';
import { selectIds, selectTotalCount } from '../../account-register/state/account-register.reducer';
import { ExtensionPrivileges } from '../../extension-details/models/extension-privileges';
import * as ExtensionDetailActions from '../../extension-details/state/extension-detail.actions';
import { AccountDetailSaveEvent } from '../models/account-detail-form-submit-event';
import { AccountPrivileges } from '../models/account-privileges';
import { GetAccountDetail_account } from '../queries/generated/GetAccountDetail';
import { AccountDetailFormService } from '../services/account-detail-form.service';
import * as AccountDetailActions from '../state/account-detail.actions';
import { getAccount, getAccountCallState } from '../state/account-detail.selectors';

@Component({
   encapsulation: ViewEncapsulation.None,
   host: { class: 'entity-detail' },
   providers: [AccountDetailFormService, { provide: FormsBase, useExisting: AccountDetailFormService }],
   selector: 'ndt-account-detail',
   templateUrl: './account-detail.component.html',
   standalone: false,
})
export class AccountDetailComponent extends NavigatableDetail<AccountDetailFormService> implements OnInit, OnDestroy {
   account$: Observable<GetAccountDetail_account | null>;

   callState$: Observable<CallState>;

   accountPrivileges$: Observable<AccountPrivileges>;

   extensionPrivileges$: Observable<ExtensionPrivileges>;

   isAdminUser$: Observable<boolean>;

   sipDomain: string;

   constructor(
      public store: Store,
      private router: Router,
      private appConfigService: AppConfigService,
      protected formService: AccountDetailFormService
   ) {
      super(store, formService);
      this.sipDomain = `.voip.netdialtone.${appConfigService.getConfig().urlEnv}`;
   }

   ngOnInit(): void {
      this.account$ = this.store.pipe(select(getAccount));
      this.callState$ = this.store.pipe(select(getAccountCallState));
      this.accountPrivileges$ = this.store.pipe(select(getAccountPrivileges));
      this.extensionPrivileges$ = this.store.pipe(select(getExtensionPrivileges));
      this.isAdminUser$ = this.store.pipe(select(getCurrentUserIsAdminUser));
      this.store.dispatch(AccountDetailActions.accountDetailLoad());
      this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((e) => {
         if (e instanceof NavigationEnd) {
            this.store.dispatch(AccountDetailActions.accountDetailLoad());
         }
      });
      this.idsFromRegister$ = this.store.pipe(select(selectIds));
      this.totalCount$ = this.store.pipe(select(selectTotalCount));
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
      this.destroyed$.complete();
   }

   onFormSaveCanceled(): void {
      this.store.dispatch(AccountDetailActions.accountDetailCancel());
   }

   onFormSubmitted(event: AccountDetailSaveEvent) {
      this.store.dispatch(AccountDetailActions.saveAccountDetail(event));
   }

   onResetMwi(event): void {
      this.store.dispatch(ExtensionDetailActions.resetMwi({ extensionId: undefined, accountId: event }));
   }

   onNavigate(id: string | number) {
      this.store.dispatch(AccountDetailActions.navigate({ id }));
   }

   onLoadIdPage() {
      this.store.dispatch(accountRegisterAdapterActions.loadIdPage());
   }
}
